import React, { useState } from "react";

// Reusable accordion node. `renderBody` is a function returning the body
// content; it is invoked only after the node is first expanded (lazy mount)
// and then kept mounted so re-collapsing does not refetch.
const AccordionNode = ({ title, levelClass, renderBody }) => {
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const toggle = () => {
    const next = !open;
    setOpen(next);
    if (next && !loaded) setLoaded(true);
  };

  return (
    <div className={"node " + (levelClass || "") + (open ? " is-open" : "")}>
      <button
        className="node__head"
        aria-expanded={open ? "true" : "false"}
        onClick={toggle}
      >
        <svg viewBox="0 0 24 24" className="node__chevron">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 9l6 6 6-6"
          />
        </svg>
        <span className="node__title">{title}</span>
      </button>
      <div className="node__body">{loaded ? renderBody() : null}</div>
    </div>
  );
};

export default AccordionNode;
